/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  FeeReceiverProxy,
  FeeReceiverProxyInterface,
} from "../FeeReceiverProxy";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "RevenueShareCallbackInvalidSender",
    type: "error",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [],
    name: "cardToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractRegistry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_cardToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_contractRegistry",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "baseFee",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "dataForCallback",
        type: "bytes",
      },
    ],
    name: "revenueShareCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "feeTokenList",
        type: "address[]",
      },
    ],
    name: "shareRevenueToFeeCollector",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

export class FeeReceiverProxy__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FeeReceiverProxy> {
    return super.deploy(overrides || {}) as Promise<FeeReceiverProxy>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): FeeReceiverProxy {
    return super.attach(address) as FeeReceiverProxy;
  }
  connect(signer: Signer): FeeReceiverProxy__factory {
    return super.connect(signer) as FeeReceiverProxy__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FeeReceiverProxyInterface {
    return new utils.Interface(_abi) as FeeReceiverProxyInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FeeReceiverProxy {
    return new Contract(address, _abi, signerOrProvider) as FeeReceiverProxy;
  }
}
